import { render, staticRenderFns } from "./EventAlarmTags.vue?vue&type=template&id=c919a544&scoped=true"
import script from "./EventAlarmTags.vue?vue&type=script&lang=ts"
export * from "./EventAlarmTags.vue?vue&type=script&lang=ts"
import style0 from "./EventAlarmTags.vue?vue&type=style&index=0&id=c919a544&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c919a544",
  null
  
)

export default component.exports